import { OsType } from 'api/models'

export const getOsName = (os?: OsType) => {
  switch (os) {
    case OsType.ANDROID:
      return 'Android'
    case OsType.IOS:
      return 'iOS'
    default:
      return String(os)
  }
}
